import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CURRENT_USER,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  UPDATE_USER_STATUS,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAILURE,
  GET_USER_STATUS,
  GET_USER_STATUS_SUCCESS,
  GET_USER_STATUS_FAILURE,
} from "./actionTypes";

const initialState = {
  user: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const authentication = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        user: action.payload.user,
        isLoggedIn: true,
      };
      break;
    case LOGOUT_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGOUT_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        user: {},
        isLoggedIn: false,
      };
      break;
    case CURRENT_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CURRENT_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        user: action.payload.currentUser,
        isLoggedIn: true,
      };
      break;

    case CURRENT_USER_FAILURE:
      state = {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };
      break;

    // get user status
    case GET_USER_STATUS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_USER_STATUS_SUCCESS: {
      const { url } = action?.payload || {};
      state = {
        ...state,
        loading: false,
        error: "",
        user: {
          ...state?.user,
          url: url,
        },
        isLoggedIn: true,
      };
      break;
    }

    case GET_USER_STATUS_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;
    // change user status
    case UPDATE_USER_STATUS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case UPDATE_USER_STATUS_SUCCESS: {
      const { subscriberUrl } = action?.payload || {};
      state = {
        ...state,
        loading: false,
        error: "",
        user: {
          ...state?.user,
          url: subscriberUrl,
        },
        isLoggedIn: true,
      };
      break;
    }

    case UPDATE_USER_STATUS_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default authentication;
